import * as React from 'react'
import { Link as RRLink } from 'react-router-dom'
import styled from 'styled-components'
import { Box, muiBankTheme } from '@ally/metronome-ui'
import { AdobeTile } from '../../types'
import AdobeIcon from '../AdobeIcon'
import { TextBodyOverride } from '../../Shared/MetronomeOverrides'

interface XLTileProps {
  tileData: AdobeTile
}

const StyledLink = styled(RRLink)`
  text-decoration: none;
  white-space: normal;
  flex-basis: 100%;
  padding-right: ${muiBankTheme.space.sm};
`

const XLTile: React.FC<XLTileProps> = ({ tileData }) => {
  return (
    <StyledLink to={tileData.ctaHref}>
      <Box display="flex" flexDirection="row" padding="xs" lineHeight="1.25">
        <AdobeIcon tileData={tileData} />
        <Box paddingLeft="xs">
          <TextBodyOverride
            tag="span"
            size="sm"
            color="bluesuedeshoes"
            weight="bold"
            aria-label={tileData.ariaText}
          >
            {tileData.title}
          </TextBodyOverride>
          <Box size="sm" color="slate-5" width="95%" fontWeight="normal">
            {tileData.subtitle}
          </Box>
        </Box>
      </Box>
    </StyledLink>
  )
}

export default XLTile
